/*
 * @providesModule Countries
 * 
 */

import _ from 'lodash';

import SkillzModule from 'SkillzModule';
import {
  NativeModules,
  Platform,
} from 'react-native';

// Exported for testing purposes ONLY. Use singleton default export
export class Countries {
  _countryData: CountryData;
  _dataLoaded: boolean;

  constructor() {
    this._countryData = null;
    this._dataLoaded = false;
  }

  getCountryNameByCode(code: string): string {
    this._loadCountryData();
    return this._countryData.getCountryNameByCode(code);
  }

  getCountryCodeByName(name: string): string {
    this._loadCountryData();
    return this._countryData.getCountryCodeByName(name);
  }

  getAllCountries(): Map<string, string> {
    this._loadCountryData();
    return this._countryData.getCountries();
  }

  // NOTE: Objects in JS do not guarantee order of keys. To preserve alphabetical order, getAllCountries is recommended.
  getAllCountriesAsObject(): {[key: string]: string} {
    this._loadCountryData();
    return this._countryData.getCountriesAsObject();
  }

  _loadCountryData() {
    if (!this._dataLoaded) {
      const countryList = Platform.OS == 'android' ? SkillzModule.SKZCountryList : NativeModules.SKZCountryList;
      this._countryData = new CountryData(countryList.countries, countryList.listSortedByName);
      this._dataLoaded = true;
    }
  }
}

export default new Countries();

// Exported for testing purposes only.
export class CountryData {
  _countries: Map<string, string>; // Map ensures order of keys

  constructor(countryData: {[string]: string}, sortedCountryNames: Array<string>) {
    this._countries = this._processCountryData(countryData, sortedCountryNames);
  }

  _processCountryData(countryData: {[string]: string}, sortedCountryNames: Array<string>): Map<string, string> {
    const countryMap = new Map();
    const countries = _.invert(countryData);

    sortedCountryNames.forEach((name: string) => {
      countryMap.set(countries[name], name);
    });

    return countryMap;
  }

  getCountries(): Map<string, string> {
    return this._countries;
  }

  // NOTE: Objects in JS do not guarantee order of keys. To preserve alphabetical order, getCountries is recommended.
  getCountriesAsObject(): {[key: string]: string} {
    const obj = {};
    this._countries.forEach((name: string, code: string) => {
      obj[code] = name;
    });
    return obj;
  }

  getCountryNameByCode(code: string): string {
    return this._countries.get(code) || '';
  }

  getCountryCodeByName(name: string): string {
    let code = '';
    for (const entry of this._countries) {
      // code: entry[0], name: entry[1]
      if (entry[1] === name) {
        code = entry[0];
        break;
      }
    }

    if (!code) {
      console.warn('Countries: no country code found for', name);
    }
    return code;
  }
}
